<!-- 弹窗预览效果弹窗内容 -->
<template>
  <div :ref="itRef" class="preview-container">
    <div class="preview-container__left">
      <vh-image
        class="preview-img"
        :src="payload.leftUrl"
        :preview-src-list="[payload.leftUrl]"
      ></vh-image>
      <p class="preview-text">{{ payload.leftText }}</p>
    </div>
    <div class="preview-container__right">
      <vh-image
        class="preview-img"
        :src="payload.rightUrl"
        :preview-src-list="[payload.rightUrl]"
      ></vh-image>
      <p class="preview-text">{{ payload.rightText }}</p>
    </div>
  </div>
</template>
<script>
  import i18n from '@/app-shared/i18n';
  export default {
    name: 'EffectPreview',
    props: {
      itRef: String,
      // 场景：
      // 1 - 聊天昵称是否加密效果
      // 2 - 禁言指定观众效果
      scene: {
        type: Number,
        default: () => {
          return 1;
        }
      }
    },
    computed: {
      payload() {
        if (this.scene === 2) {
          return {
            leftText: i18n.t('host.k_660001'),
            leftUrl: `${process.env.VUE_APP_STATIC_BASE}/common-static/images/chat/chat_banned_mode_0.png`,
            rightText: i18n.t('host.k_660002'),
            rightUrl: `${process.env.VUE_APP_STATIC_BASE}/common-static/images/chat/chat_banned_mode_1.png`
          };
        } else {
          return {
            leftText: i18n.t('host.k_660003'),
            leftUrl: `${process.env.VUE_APP_STATIC_BASE}/common-static/images/chat/chat_nickname_encryption_0.png`,
            rightText: i18n.t('host.k_660004'),
            rightUrl: `${process.env.VUE_APP_STATIC_BASE}/common-static/images/chat/chat_nickname_encryption_1.png`
          };
        }
      }
    }
  };
</script>
<style lang="less">
  .custom-message-box {
    min-width: 600px;
  }
  .preview-container {
    display: flex;

    &__right {
      margin-left: 20px;
    }

    .preview-text {
      text-align: center;
    }
  }
</style>
